"use client";

import { FC } from "react";
import Image from "next/image";

interface LogoProps {
  variant?: "light" | "dark";
  size?: "small" | "medium" | "large";
  showText?: boolean;
  className?: string;
  useImage?: boolean;
}

const Logo: FC<LogoProps> = ({
  variant = "light",
  size = "medium",
  showText = true,
  className = "",
  useImage = true,
}) => {
  // Define image sizes based on size prop
  const imageSizes = {
    small: { width: 75, height: 75 },
    medium: { width: 100, height: 75 },
    large: { width: 150, height: 100 },
  };

  // Define styles based on props
  const styles = {
    container: `flex items-center gap-1 ${className}`,
    logoBox: {
      base: "rounded-lg flex items-center justify-center",
      light: "bg-light",
      dark: "bg-primary",
      small: "w-12 h-6",
      medium: "w-15 h-7",
      large: "w-18 h-9",
    },
    logoText: {
      light: "text-primary",
      dark: "text-light",
      small: "text-lg",
      medium: "text-xl",
      large: "text-2xl",
    },
    brandText: {
      light: "text-light",
      dark: "text-primary",
      small: "text-xl",
      medium: "text-2xl",
      large: "text-3xl",
    },
  };

  const logoBoxClasses = `${styles.logoBox.base} ${styles.logoBox[variant]} ${styles.logoBox[size]}`;
  const logoTextClasses = `font-bold ${styles.logoText[variant]} ${styles.logoText[size]}`;
  const brandTextClasses = `font-bold ${styles.brandText[variant]} ${styles.brandText[size]}`;

  return (
    <div className={styles.container}>
      {useImage ? (
        <div className="flex items-center">
          <Image
            src={variant === "light" ? "/logo-light.png" : "/logo-dark.png"}
            alt="Mollo Logo"
            width={imageSizes[size].width}
            height={imageSizes[size].height}
            priority
          />
        </div>
      ) : (
        <>
          <div className={logoBoxClasses}>
            <span className={logoTextClasses}>Mollo</span>
          </div>
          {showText && <h1 className={brandTextClasses}>AI</h1>}
        </>
      )}
    </div>
  );
};

export default Logo;